<style lang="scss" scoped>
.custom-tree-node {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  padding-right: 8px;
}
</style>
<template>
  <el-card shadow="never" class="l-main-card">
    <!--左边角色选择-->
    <div class="l-container-sider">
      <l-role-list ref="roleList" @on-before-check="beforeCheckRole" @on-after-check="aftercheckRole" :id="of_type"></l-role-list>
    </div>

    <!--右边菜单列表-->
    <div class="l-container-content">
      <div class="l-menu-box">
        <div class="l-container-title">
          <i class="el-icon-menu" /><b>菜单授权</b>
          <l-auth-text-button auth="menu_add_btn" type="primary" style="float:right;font-size:14px" @click="showAdd('')">
            <i class="el-icon-plus" style="font-size:14px;" />添加
          </l-auth-text-button>
        </div>
        <div class="l-menu-list-main" v-loading="spinning">
          <el-tree :data="menu_tree" show-checkbox node-key="id" :props="{label:'menu_name'}" default-expand-all :expand-on-click-node="false" :default-checked-keys="role_menu_ids" @check-change="onCheckChange">
            <span class="custom-tree-node" slot-scope="{ node, data }">
              <span>{{ node.label }}</span>
              <span>
                <l-auth-text-button auth="menu_add_btn" type="primary" @click="showAdd(data.id)" v-show="data.is_node==1">
                  添加子菜单
                </l-auth-text-button>
                <l-auth-text-button auth="menu_edit_btn" type="primary" @click="showEdit(data.id)">
                  编辑
                </l-auth-text-button>
                <l-auth-text-button auth="menu_del_btn" type="danger" @click="del(data.id)">
                  删除
                </l-auth-text-button>
              </span>
            </span>
          </el-tree>
        </div>

        <div class="l-menu-footer">
          <el-button type="primary" @click="save" :loading="submitting">保存</el-button>
        </div>
      </div>
    </div>

    <!--添加-->
    <l-dialog :visible.sync="show_add" title="添加菜单">
      <l-menu-edit @on-success="onAddSucess" :visible.sync="show_add" :pid="add_pid"></l-menu-edit>
    </l-dialog>

    <!--编辑-->
    <l-dialog :visible.sync="show_edit" title="编辑菜单">
      <l-menu-edit @on-success="onEditSucess" :visible.sync="show_edit" :id="edit_id"></l-menu-edit>
    </l-dialog>

  </el-card>
</template>

<script>
import RoleList from '../role/RoleList'
import Edit from './Edit'
export default {
  name: 'menu-index',
  components: {
    [RoleList.name]: RoleList,
    [Edit.name]: Edit,
  },

  data() {
    return {
      of_type: 1,
      role_id: '',
      spinning: false,

      submitting: false,

      menu_tree: [],
      role_menu_ids: [],
      re_role_menu_ids: [],


      show_add: false,
      add_pid: '',

      show_edit: false,
      edit_id: '',
    }
  },

  methods: {
    //选择角色前的回调
    beforeCheckRole() {
      this.spinning = true;
    },

    //选择角色后的回调
    aftercheckRole(id) {
      this.$_invoke(`roleMenu_getListByRoleId`, { id }).then((ret) => {
        this.role_id = id;
        this.spinning = false;
        this.role_menu_ids = ret.role_menu_ids;
        this.re_role_menu_ids = ret.role_menu_ids.concat([]);
        this.menu_tree = ret.menu_tree;
      });
    },


    //监听菜单选择
    onCheckChange(selection, is_check) {
      //是否选中
      const index = this.role_menu_ids.findIndex(item => {
        return item == selection.id;
      })
      if (!is_check) {
        if (index !== -1) {
          this.role_menu_ids.splice(index, 1);
        }
      } else {
        if (index === -1) {
          this.role_menu_ids.push(selection.id);
        }
      }
    },

    //保存当前授权的菜单
    save() {
      this.submitting = true;
      this.$_invoke(`roleMenu_save`, {
        role_id: this.role_id,
        role_menu_ids: this.role_menu_ids,
        re_role_menu_ids: this.re_role_menu_ids
      }).then(() => {
        this.$_msg.success('保存成功');
        this.$refs.roleList.checkRole(this.role_id);
      }).finally(() => {
        this.submitting = false;
      });
    },

    //打开添加页面
    showAdd(id) {
      this.add_pid = id;
      this.show_add = true;
    },

    //添加成功回调
    onAddSucess() {
      this.show_add = false;
      this.$refs.roleList.checkRole(this.role_id);
    },


    //显示修改界面
    showEdit(id) {
      this.edit_id = id;
      this.$nextTick(() => {
        this.show_edit = true;
      });
    },

    //编辑成功回调
    onEditSucess() {
      this.show_edit = false;
      this.$refs.roleList.checkRole(this.role_id);
    },

    //删除菜单
    del(id) {
      this.$confirm('确定删除该条记录吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        this.$_invoke(`menu_delete`, { id }).then(() => {
          this.$_msg.success('删除成功');
          this.$refs.roleList.checkRole(this.role_id);
        });
      }).catch(() => {
      });
    },
  }
}
</script>